import AppDownload from "../components/app/appDownload";
export default function AppDownloadPage() {
  return <AppDownload />;
}

